/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienZendeskViewProps } from './obrien-zendesk';

export default (props: IObrienZendeskViewProps) => {
    return (
        <>
        <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=06de386f-2858-4c52-b67e-7eb14c4c9162"> </script>
        </>
    );
};
